module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Brush-11415419db0a16e0134c8255c64dfb3c.svg";